import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {

  extends: Bar,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    this.renderChart(this.chartData, {
      maintainAspectRatio:false,
      tooltips: {
        mode: 'index',
        callbacks: {
          label: function(tooltipItems) {
            if (!tooltipItems.yLabel) return 'N/A'
            return tooltipItems.yLabel.toFixed(2);
          }
        }
      },
      scales: {
        xAxes: [{
          ticks: {
            autoSkip: false,
            maxRotation: 0,
            fontFamily: 'Museo_Sans',
            fontSize: 14
          },
          gridLines: {
            display: false
          }
        }],
        yAxes: [{
          ticks: {
            min: 1,
            max: 4,
            maxTicksLimit: 5,
            fontFamily: 'Museo_Sans',
            fontSize: 20
          },
          gridLines: {
            display: true,
            color: '#9b9b9b'
          },
          scaleLabel: {
            display: true,
            labelString: 'Component Average',
            fontSize: 20,
            fontStyle: 'bold',
            fontFamily: 'Museo_Sans'
          }
        }]
      },
      legend: {
        display: true,
        position: 'right',
        labels: {
          fontColor: '#39393a',
          fontFamily: 'Museo_Sans',
          fontSize: 14,
          boxWidth: 20
          
        }
      }
    })
  }

}